import { useEffect, useState } from 'react'

export const useMediaDevices = () => {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([])

  useEffect(() => {
    function handleChange() {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          setDevices(devices.filter((device) => device.deviceId !== 'default' && device.deviceId !== 'communications'))
        })
        .catch(console.log)
    }

    /**
     * this should prompt the chrome message
     */
    async function permissionChecked() {
      try {
        const readyStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
        readyStream.getTracks().forEach(function (track) {
          track.stop()
        })
        handleChange()
      } catch {
        alert('Please grant permissions for camera and microphone')
      }
    }

    navigator.mediaDevices.addEventListener('devicechange', handleChange)

    permissionChecked()

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', handleChange)
    }
  }, [])

  return devices
}

export default useMediaDevices
